export default "__VITE_ASSET__BnMQMpjN__"